import ScrollContainer from "react-indiana-drag-scroll";
import { Header } from "./tabHeader";
import { PropTypes } from 'prop-types';
import { useRef, useState, useEffect } from 'react';
import { FaChevronLeft, FaChevronRight } from 'react-icons/fa'; // Using react-icons for arrows

const TabHeaders = ({ headers, activeTab, className, handleTabClick }) => {
  const scrollRef = useRef(null);
  const [isScrollable, setIsScrollable] = useState(false);

  // Function to scroll left
  const scrollLeft = () => {
    if (scrollRef.current) {
      scrollRef.current.scrollBy({ left: -150, behavior: 'smooth' });
    }
  };

  // Function to scroll right
  const scrollRight = () => {
    if (scrollRef.current) {
      scrollRef.current.scrollBy({ left: 150, behavior: 'smooth' });
    }
  };

  // Check if content is scrollable
  useEffect(() => {
    const checkScrollable = () => {
      if (scrollRef.current) {
        const { scrollWidth, clientWidth } = scrollRef.current;
        setIsScrollable(scrollWidth > clientWidth);
      }
    };

    checkScrollable();
    window.addEventListener('resize', checkScrollable);
    return () => window.removeEventListener('resize', checkScrollable);
  }, [headers]);

  return (
    <div className="flex w-full items-center">
      {/* Left Arrow Button (visible on mobile) */}
      <button
        onClick={scrollLeft}
        className="p-2 bg-white bg-opacity-80 rounded shadow-md md:hidden flex-shrink-0"
        aria-label="Scroll tabs left"
      >
        <FaChevronLeft className="text-gray-600" />
      </button>

      {/* Scrollable Container for Tabs */}
      <ScrollContainer
        horizontal
        innerRef={scrollRef}
        className={`flex-1 flex gap-3 lg:gap-5 scroll-smooth snap-mandatory snap-x overflow-x-auto lg:scroll-px-3 mx-2 ${
          isScrollable ? 'justify-start' : 'justify-center'
        }`}
        role="tablist"
      >
        {headers?.map((header, index) => (
          <Header
            key={index}
            text={header}
            className={className}
            isActive={index === activeTab}
            onClick={() => handleTabClick(index)}
          />
        ))}
      </ScrollContainer>

      {/* Right Arrow Button (visible on mobile) */}
      <button
        onClick={scrollRight}
        className="p-2 bg-white bg-opacity-80 rounded shadow-md md:hidden flex-shrink-0"
        aria-label="Scroll tabs right"
      >
        <FaChevronRight className="text-gray-600" />
      </button>
    </div>
  );
};

TabHeaders.propTypes = {
  headers: PropTypes.array,
  activeTab: PropTypes.number,
  handleTabClick: PropTypes.func,
};

export default TabHeaders;